import { render, staticRenderFns } from "./menu-manage.vue?vue&type=template&id=11a77ddb&scoped=true&"
import script from "./menu-manage.vue?vue&type=script&lang=js&"
export * from "./menu-manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a77ddb",
  null
  
)

export default component.exports